import mlFunctionsClient from '../interceptor.mlFunctionsClient';

const gpsPipelineEndpoints = {
  processPoint: (data, config) =>
    mlFunctionsClient.post('/ProcessGPSPoint', data, config),

  processBatch: (data, config) =>
    mlFunctionsClient.post('/ProcessGPSBatch', data, config),

  getQualityStats: (config) =>
    mlFunctionsClient.get('/GetGPSQualityStats', config),

  checkSpoofing: (data, config) =>
    mlFunctionsClient.post('/CheckSpoofing', data, config),

  getLastProcessedPoint: (config) =>
    mlFunctionsClient.get('/GetLastProcessedPoint', config),

  getSpoofHistory: (config) =>
    mlFunctionsClient.get('/GetSpoofHistory', config),
};

export default gpsPipelineEndpoints;
